import { Fragment, useEffect } from 'react';
import {Formik} from "formik";
import * as Yup from "yup";

const Organisation = ({ state, updateState, nextStep, previousStep }) => {
  useEffect(() => {
    if (!state?.data?.company_information?.industry_bodies.includes('atol')) {
      if (state.stepDirection === 'next') {
        nextStep();
      } else {
        previousStep();
      }
    }
  }, [state]);

  return (
    <Formik
      initialValues={{
        atol_number: state?.data?.atol?.atol_number || '',
      }}
      validationSchema={Yup.object().shape({
        atol_number: Yup
          .string()
          .required('ATOL Number is required'),
      })}
      onSubmit={async (values, {
        setSubmitting
      }) => {
        setSubmitting(true);
        updateState('atol', values);
        nextStep();
      }}
    >
      {({
          errors,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
          touched,
          values,
          setFieldValue,
        }) => (
        <Fragment>
          <form action="#" method="POST" onSubmit={handleSubmit}>

          <h1 className="text-2xl font-semibold mb-6">ATOL Membership</h1>

            <div className="grid grid-cols-1 gap-x-8 gap-y-6 sm:grid-cols-2">

              <div className="sm:col-span-2 mb-2">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-state">
                  ATOL Number *
                </label>
                <div className="mt-2.5">
                  <input type="text"
                         name="atol_number"
                         id="atol_number"
                         value={values.atol_number}
                         onBlur={handleBlur}
                         onChange={handleChange}
                         autoComplete="organization"
                         placeholder={'e.g. 4582'}
                         className={`block appearance-none w-full rounded-md border border-gray-200 text-gray-900 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500${touched.atol_number && errors.atol_number ? ' border-red-500' : ''}`}
                  />
                  {touched.atol_number && errors.atol_number && <div className="field-error">{errors.atol_number}</div>}
                </div>
              </div>

            </div>

            <div className="mt-12">
              <button type="submit"
                      className="bg-purple-800 disabled:bg-purple-200 hover:bg-purple-900 text-white font-semibold rounded-md py-2 px-4 w-full">
                Next
              </button>
            </div>

            <div className="mt-4">
              <button type="button"
                      onClick={previousStep}
                      className="block w-full rounded-md bg-slate-300 px-3.5 py-2.5 text-center text-md font-semibold text-black shadow-sm hover:text-white hover:bg-slate-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-slate-600">
                Previous
              </button>
            </div>
          </form>
        </Fragment>
      )}
    </Formik>
  );
}

export default Organisation;
